"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInWithProvidersModal = void 0;
const SignInWithProviderButtons_1 = require("root/src/client/v2/auth/components/SignInWithProviderButtons");
const ModalTitle_1 = require("root/src/client/v2/common/components/modal/ModalTitle");
const ModalLayout_1 = require("../../common/layouts/ModalLayout");
function SignInWithProvidersModal() {
    return (<ModalLayout_1.ModalLayout>
			<ModalTitle_1.ModalTitle>Connect Channels</ModalTitle_1.ModalTitle>
			<div className="flex flex-col w-[280px] gap-3">
				<SignInWithProviderButtons_1.SignInWithProviderButtons isLinking/>
			</div>
		</ModalLayout_1.ModalLayout>);
}
exports.SignInWithProvidersModal = SignInWithProvidersModal;
